import Repository from "./Repository";
import Assessment from "../types/Assessment";

const resource = "/assessment";

export default {
  save(assessment: Assessment) {
    return Repository.post(`${resource}`, assessment);
  }
};
